import useAxios from 'hooks/useAxios';

export async function editItem(id, name, gems, coins, type, rarity, unrealItemId, tags, metadata, itemId, isActive) {
  const api = useAxios();
  const payload = {
    name,
    priceGems: gems,
    priceCoins: coins,
    type,
    rarity,
    unrealItemId
  };

  // Optional fields
  if (tags !== undefined && tags !== '') {
    payload.tags = tags;
  }
  if (metadata !== undefined && metadata !== '') {
    payload.metadata = metadata;
  }
  if (itemId !== undefined && itemId !== '') {
    payload.itemId = itemId;
  }
  if (typeof isActive === 'boolean') {
    payload.isActive = isActive;
  }

  try {
    const res = await api.patch(`/items/${id}`, payload);
    return res;
  } catch (err) {
    return err;
  }
}
